import translate from "@insite/client-framework/Translate";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { FC, useEffect } from "react";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";
import { ResolveThunks, connect } from "react-redux";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import ADIColors from "@NA/Utils/ADIColors";
import Img, { ImgProps } from "@insite/mobius/Img";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";

interface OwnProps {
    liveChatURL?: string;
    deviceType?: string;
    isAuthenticated?: boolean;
    livechat_firstName?: string;
    livechat_lastName?: string;
    livechat_email?: string;
    billToCustomerNo?: string;
    livechat_accountNumber?: string;
    isHeaderDrawer?: true;
    isFooter?: boolean;
    isModal?: boolean;
    adiNoSearchContactUs?: boolean;
    contactUsPage?: boolean;
    adiNoSearchResults?: boolean;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ADILiveChatComponentStyles {
    mainText: TypographyProps;
    homePageChatNowWrapper: InjectableCss;
    homePageChatNowText: TypographyProps;
    homePageChatNowHeadingText: TypographyProps;
    homePageChatSubHeadingText: TypographyProps;
    homePageChatNowImgWrapper: InjectableCss;
    homePageChatNowImg: InjectableCss;
    headerChatWithUsWrapper: InjectableCss;
    headerChatWithUsLink: InjectableCss;
    modalChatWithUsLink?: InjectableCss;
    noSearchContactChatWithUs?: InjectableCss;
    noSearchContactChatWithUsText?: InjectableCss;
    noSearchResultsText?: InjectableCss;
    contactUsChatWithUs?: InjectableCss;
    contactUsChatWithUsLink?: InjectableCss;
    contactUsChatWithUsContent?: InjectableCss;
    chatWithUsContent?: InjectableCss;
    text6?: TypographyProps;
    text10?: ImgProps;
    needAssistance?: TypographyProps;
    outlineButton?: TypographyProps;
    needAssistanceBottomText?: TypographyProps;
}

export const adiLiveChatComponentStyles: ADILiveChatComponentStyles = {
    noSearchResultsText: {
        css: css`
            font-size: 14px;
            color: ${ADIColors.blue5};
            text-decoration: underline;
            cursor: pointer;
            &:hover {
                color: ${ADIColors.darkBlue7};
                text-decoration: underline;
            }
        `,
    },
    needAssistanceBottomText: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                    null,
                ]);
            }},
            width: 221px;
            height: 19px;
            flex-grow: 0;
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: ${ADIColors.gray6};
        `,
    },
    noSearchContactChatWithUsText: {
        css: css`
            font-size: 14px;
            font-weight: 700;
            color: ${ADIColors.blue5};
            cursor: pointer;
            &:hover {
                text-decoration: underline;
            }
        `,
    },
    text6: {
        css: css`
            margin-bottom: 16px;
        `,
    },
    needAssistance: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                ]);
            }}
            flex-grow: 0;
            font-size: 22px;
            font-weight: 800;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: left;
            color: #fff;
            margin-left: 13px;
            padding-bottom: 10px;
            margin-top: 5px;
        `,
    },
    outlineButton: {
        css: css`
            width: 300px;
            height: 40px;
            flex-grow: 0;
            padding: 7px 100px;
            border-radius: 6px;
            border: solid 1px #fff;
            cursor: pointer;
            display: block;
            &:hover {
                background-color: ${ADIColors.lightGreenBg} !important;
                color: ${ADIColors.white} !important;
                > ${TypographyStyle} {
                    background-color: ${ADIColors.lightGreenBg} !important;
                    color: ${ADIColors.white} !important;
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        border: none;
                    `,
                    css`
                        border: none;
                    `,
                    null,
                    null,
                    null,
                ]);
            }}
        `,
    },
    text10: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                ]);
            }}
            width: 34px;
            height: 37px;
            object-fit: none;
        `,
    },
    modalChatWithUsLink: {
        css: css`
            display: inline-flex;
            @media only screen and (max-width: 1080px) {
                display: none;
            }
        `,
    },
    noSearchContactChatWithUs: {
        css: css`
            display: flex;
            flex-direction: column;
            margin-top: 12px;
            @media only screen and (max-width: 1080px) {
                display: none;
            }
            .businessHoursText {
                font-size: 14px;
                font-weight: normal;
                color: ${ADIColors.darkBlack2};
            }
        `,
    },
    contactUsChatWithUsLink: {
        css: css`
            display: inline-flex;
            margin: 0 auto;
            font-size: 14px;
            font-weight: 700;
            color: ${ADIColors.blue5};
            cursor: pointer;
            &:hover {
                color: ${ADIColors.blue1};
                text-decoration: underline;
            }
        `,
    },
    contactUsChatWithUs: {
        css: css`
            display: flex;
            flex-direction: column;
            margin-top: 12px;
            @media only screen and (max-width: 1080px) {
                display: none;
            }
        `,
    },
    contactUsChatWithUsContent: {
        css: css`
            font-size: 14px;
            font-weight: normal;
            color: ${ADIColors.darkBlack2};
        `,
    },
    mainText: {
        css: css`
            color: white;
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
        `,
    },
    homePageChatNowWrapper: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-left: 7px;
            border-left: 1px solid ${ADIColors.gray2};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: flex;
                    `,
                ])}
        `,
    },
    homePageChatNowText: {
        css: css`
            color: ${getColor("primary")};
            text-align: center;
            font-weight: 800;
            font-size: 14px;
            cursor: pointer;
            font-style: normal !important;
            margin-bottom: 0px;
            :hover {
                text-decoration: underline;
            }
            :focus-visible {
                outline: 1px solid ${ADIColors.blue5};
            }
        `,
    },
    homePageChatNowHeadingText: {
        css: css`
            text-align: center;
            margin-bottom: 6px !important;
            margin-top: 0px !important;
            color: ${ADIColors.darkBlack3};
            font-style: normal !important;
            font-weight: 800;
            font-size: 20px;
            line-height: 24px;
        `,
    },
    chatWithUsContent: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
        `,
    },
    homePageChatNowImgWrapper: {
        css: css`
            width: 40px;
            height: 44.78px !important;
            margin-bottom: 10px !important;
        `,
    },
    homePageChatNowImg: {
        css: css`
            width: 100%;
            cursor: pointer;
        `,
    },
    headerChatWithUsWrapper: {
        css: css`
            width: 100%;
            background: ${getColor("common.accent")};
            text-align: center;
            cursor: auto;
        `,
    },
    headerChatWithUsLink: {
        css: css`
            font-size: 12px;
            font-weight: bold;
            padding: 23px 0;
            display: block;
            line-height: normal;
            width: 100%;
            cursor: pointer;
            color: ${getColor("text.main")};
            &:hover {
                text-decoration: underline;
            }
            > span {
                color: ${getColor("text.main")} !important;
                &:hover {
                    text-decoration: underline;
                }
            }
        `,
    },
    homePageChatSubHeadingText: {
        css: css`
            color: ${ADIColors.gray4};
            font-size: 14px;
            line-height: 1.71;
            margin-bottom: 9px !important;
            text-align: center;
            font-style: normal !important;
            font-family: "Open Sans", sans-serif !important;
        `,
    },
};

const mapStateToProps = (state: CustomApplicationState) => {
    const billToId = state.context.session.billToId;
    let livechat_accountNumber;
    if (billToId) {
        livechat_accountNumber = state.data.billTos.byId[billToId]?.customerNumber;
    }

    return {
        liveChatURL: getSettingsCollection(state).customerSettings.liveChatURL,
        deviceType: state.context.session.deviceType,
        isAuthenticated: state.context.session.isAuthenticated,
        livechat_firstName: state.context.session.firstName,
        livechat_lastName: state.context.session.lastName,
        livechat_email: state.context.session.email,
        billToCustomerNo: state.context.session.billToId,
        livechat_accountNumber,
    };
};

const mapDispatchToProps = {
    toggleLoginDrawer,
};

const styles = adiLiveChatComponentStyles;

const ADILiveChatComponent: FC<Props> = ({
    liveChatURL,
    deviceType,
    isAuthenticated,
    livechat_firstName,
    livechat_lastName,
    livechat_accountNumber,
    livechat_email,
    isModal,
    isFooter,
    adiNoSearchContactUs,
    contactUsPage,
    isHeaderDrawer,
    adiNoSearchResults,
    toggleLoginDrawer,
}) => {
    useEffect(() => {
        if (deviceType === "Desktop" && liveChatURL != "") {
            document.querySelectorAll(".livechat_hide_control").forEach(function (element) {
                if (element instanceof HTMLElement) {
                    element.style.display = "block";
                }
            });
        } else {
            document.querySelectorAll(".livechat_hide_control").forEach(function (element) {
                if (element instanceof HTMLElement) {
                    element.style.display = "none";
                }
            });
        }
    }, []);

    const openChat = () => {
        if (isAuthenticated) {
            const popup: string = "popUpWindow";
            const popupParam: string =
                "height=551,width=344,left=100,top=100,resizable=false,scrollbars=false,toolbar=false,menubar=no,location=no,directories=no,status=yes";

            if (liveChatURL) {
                const result =
                    liveChatURL +
                    "firstName=" +
                    livechat_firstName +
                    "&lastName=" +
                    livechat_lastName +
                    "&accountNumber=" +
                    livechat_accountNumber?.toString().replace("-", "") +
                    "&email=" +
                    livechat_email;
                window.open(result, popup, popupParam);
            }
        } else {
            toggleLoginDrawer({ loginDrawer: true });
        }
    };

    if (!isAuthenticated) {
        return null;
    }

    if (isHeaderDrawer) {
        return (
            <StyledWrapper {...styles.headerChatWithUsWrapper}>
                <StyledWrapper
                    className="myAccountMenuLink"
                    {...styles.headerChatWithUsLink}
                    onClick={openChat}
                    data-category-name={`myAccountMenu`}
                >
                    {translate("CHAT WITH US")}
                </StyledWrapper>
            </StyledWrapper>
        );
    }

    if (isModal) {
        return (
            <StyledWrapper {...styles.modalChatWithUsLink} onClick={openChat}>
                <Typography {...styles.mainText} onClick={openChat}>
                    {translate("Chat With Us")}
                </Typography>
            </StyledWrapper>
        );
    }

    if (isFooter) {
        return (
            <StyledWrapper {...styles.noSearchContactChatWithUs} onClick={openChat}>
                <Typography style={{ display: "flex", paddingLeft: "8%", marginBottom: "10px" }}>
                    <Img
                        {...styles.text10}
                        src="https://adiglobaldistribution.us/UserFiles/US/userfiles/Images/footer/chat-footer.svg"
                    />
                    <Typography as="span" {...styles.needAssistance}>
                        Need Assistance?
                    </Typography>
                </Typography>
                <Typography as="div" {...styles.text6}>
                    <Typography as="span" {...styles.outlineButton}>
                        <Typography {...styles.mainText} onClick={openChat}>
                            {translate("Chat With Us")}
                        </Typography>
                    </Typography>
                </Typography>
                <Typography as="span" {...styles.needAssistanceBottomText}>
                    Monday to Friday 8am to 7pm EST
                </Typography>
            </StyledWrapper>
        );
    }

    if (adiNoSearchContactUs) {
        return (
            <StyledWrapper {...styles.noSearchContactChatWithUs}>
                <Typography as="p" {...styles.noSearchContactChatWithUsText} onClick={openChat}>
                    {translate("Chat With Us")}
                </Typography>
                <Typography as="p" className="businessHoursText">
                    {translate("Business hours: M-F 8am EST - 7pm EST")}
                </Typography>
            </StyledWrapper>
        );
    }

    if (contactUsPage) {
        return (
            <StyledWrapper {...styles.contactUsChatWithUs}>
                <Typography as="p" {...styles.contactUsChatWithUsLink} onClick={openChat}>
                    {translate("Chat With Us")}
                </Typography>
                <Typography as="p" {...styles.contactUsChatWithUsContent}>
                    {translate("Business hours: M-F 8am EST - 7pm EST")}
                </Typography>
            </StyledWrapper>
        );
    }
    if (adiNoSearchResults) {
        return (
            <Typography as="p" {...styles.noSearchResultsText} onClick={openChat}>
                {translate("Click here to chat with a Customer Service Agent.")}
            </Typography>
        );
    }

    return (
        <StyledWrapper {...styles.homePageChatNowWrapper}>
            <StyledWrapper {...styles.homePageChatNowImgWrapper}>
                <Img
                    loading="eager"
                    onClick={openChat}
                    {...styles.homePageChatNowImg}
                    src="/userfiles/Images/Themes/home/chat-with-us-3.svg"
                />
            </StyledWrapper>
            <StyledWrapper>
                <Typography {...styles.homePageChatNowHeadingText} variant="h3">
                    {translate("Chat With Us")}
                </Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.chatWithUsContent}>
                <Typography {...styles.homePageChatSubHeadingText} variant="p">
                    {translate("Our chat agents are available M-F between 8 a.m. and 7 p.m. EST")}
                </Typography>
                <Typography variant="p" tabIndex={0} {...styles.homePageChatNowText} onClick={openChat}>
                    {translate("Chat now")}
                </Typography>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ADILiveChatComponent);
